import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import AppsIcon from '@material-ui/icons/Apps';

import MainAppBar from '../../containers/main-appbar';
import MainContent from '../../containers/main-content';
import MainDrawer from '../../containers/main-drawer';
import ProjectSelector from '../../containers/main-project-selector';
import { withDefaultStyles } from '../../utils/material-ui/hoc';
import Content from './containers/content';

class IntegrationMain extends React.Component<any, any> {
  public render() {
    return (
      <div style={this.props.style}>
        <MainAppBar title={this.props.tenant.integrations.find(c => 
            c.path === this.props.match.params.integrationid).text}>
          <ProjectSelector style={{ width: '30%' }} />
        </MainAppBar>
        <MainDrawer>
          <List>
            <ListItem button={true} key='integrations' onClick={this.navToIntegrations}>
              <ListItemIcon><AppsIcon /></ListItemIcon>
              <ListItemText>Integrations</ListItemText>
            </ListItem>
            <List style={{ paddingLeft: '10px' }}>
              {this.props.tenant.integrations.map((conf, index) => (
                /* tslint:disable:jsx-no-lambda */
                <ListItem button={true} key={conf.name}
                    onClick={() => this.navToIntegration(conf.path || conf.name)}
                    selected={this.props.match.params.integrationid === (conf.path || conf.name)}>
                  <ListItemText>{conf.text}</ListItemText>
                </ListItem>
              ))}
            </List>
          </List>
        </MainDrawer>
        <MainContent>
          <Content />
        </MainContent>
      </div>
    );
  }

  private navToIntegration = (key: string) => this.props.history.push('/console/tenants/' + this.props.tenant.id + '/integrations/' + key)
  private navToIntegrations = () => this.props.history.push('/console/tenants/' + this.props.tenant.id + '/integrations')
}

const mapStateToProps = (state, ownProps) => {
  return { ...state };
}

export default withDefaultStyles(withRouter(connect(
  mapStateToProps,
)(IntegrationMain)));



// WEBPACK FOOTER //
// ./src/sub-projects/integration/main.tsx